<!--START: header-->
<landing-app-header *ngIf="userRole == null"></landing-app-header>
<!--END: header-->

<div [ngClass]="{'without-login' : userRole == null}">
  <div class="{{PageClass}} product-to-design"
       [ngClass]="{'container-fluid' : userRole == 'SuperAdmin' || userRole == 'CustomerService', 'remove-margin' : fn_IsAddProductUrl() }">
    <div class="content-start">
      <div class="row upload-section">
        <div class="col-md-4">
          <h5 class="page-title">
            {{categoryHeader}}
            <span class="clearfix"></span>
          </h5>

          <i *ngIf="mobileScreen" class="fa fa-filter mobile-filter-icon d-md-none" aria-hidden="true"
             data-toggle="modal" data-target="#open-mobile-filter"></i>

        </div>
        <div *ngIf="fn_ShowUploadButtons()" class="col-md-4 dv-file-upld">
          <label>Update product info</label>
          <ng-container>
            <button mat-icon-button matTooltip="Upload products info" class="btn btn-upload"
              (click)="fn_OpenUploadDialog()">
              <mat-icon aria-hidden="false" class="mat-icn-up" aria-label="file upload">file_upload</mat-icon>
            </button>
            &nbsp;
            <a mat-icon-button matTooltip="Download products info" (click)="fn_downloadProductFeatures()" class="btn btn-upload">
              <mat-icon aria-hidden="false" aria-label="file upload" class="mat-icn-dwn">file_download</mat-icon>
            </a>
          </ng-container>
        </div>
        <!-- <div *ngIf="fn_ShowUploadButtons()" class="col-md-4 dv-file-upld">
          <label>Update shipping cost info</label>
          <ng-container>
            <button mat-icon-button matTooltip="Upload ship cost info" class="btn btn-upload"
              (click)="fn_OpenUploadShipCostDialog()">
              <mat-icon aria-hidden="false" aria-label="file upload" class="mat-icn-up">file_upload</mat-icon>
            </button>
            &nbsp;
            <a mat-icon-button matTooltip="Download ship cost info" (click)="fn_downloadShipCost()"
              class="btn btn-upload">
              <mat-icon aria-hidden="false" aria-label="file upload" class="mat-icn-dwn">file_download</mat-icon>
            </a>
          </ng-container>
        </div> -->
      </div>

      <div class="row">
        <div class="col-md-3 col-sm-4">
          <div class="white-background d-none d-md-block" *ngIf="!mobileScreen">
            <app-filter (getProducts)="updateProductList($event)" [filterModel]="filterModel" [filterList]="filterList"
                        [pageSize]="pageSize" [searchCustomizedForm]="searchForm"></app-filter>
          </div>
        </div>
        <div class="col-md-9 col-sm-8">
          <!-- Design Preview Section (hidden in browse-only mode) -->
          <div class="design-preview-banner" *ngIf="designData && !isBrowseOnly">
            <div class="design-preview-left">
              <div class="design-thumbnail">
                <!-- designBannerSrc is the raw URL for images and a rasterized PNG for PDFs, which
                     an <img> cannot decode on its own. -->
                <img *ngIf="designBannerSrc"
                     [src]="designBannerSrc"
                     alt="{{designData.name || (designData.file ? designData.file.name : 'Design')}}">
                <i class="fa fa-spinner fa-spin design-thumbnail-icon" *ngIf="isRenderingDesignBanner"></i>
                <i class="fa fa-file-pdf-o design-thumbnail-icon"
                   *ngIf="!designBannerSrc && !isRenderingDesignBanner"></i>
              </div>
              <div class="design-info">
                <p class="design-label">Your Design</p>
                <h4 class="design-name">{{designData.name || (designData.file ? designData.file.name : 'Uploaded Design')}}</h4>
              </div>
            </div>
            <div class="design-preview-right">
              <button
                mat-raised-button
                class="mat-btn mat-primary btn-continue-with-products"
                (click)="continueWithSelectedProducts()"
                [disabled]="selectedProductsCount === 0 || exportPreviewsInFlight > 0">
                <span *ngIf="exportPreviewsInFlight > 0">
                  <i class="fa fa-spinner fa-spin"></i> Generating Previews...
                </span>
                <span *ngIf="exportPreviewsInFlight === 0">
                  <i class="fa fa-arrow-right"></i> Continue with {{selectedProductsCount}} Product{{selectedProductsCount !== 1 ? 's' : ''}}
                </span>
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <form class="searcProductsCustomized" [formGroup]="searchForm">
                <i class="fa fa-search" aria-hidden="true"></i>
                <input class="form-control" placeholder="Search Product Catalog..." formControlName="searchProduct"
                       ng-model-options="{debounce: 10000}" (change)="fn_searchProducts()">
              </form>
            </div>
          </div>

          <div [ngClass]="{'panel-step':true,'active':listPanels.category}">
            <div class="row">
              <div class="col-sm-3" *ngFor="let cat of Categories; index as i">
                <div class="cat-item-thumb">
                  <div class="cat-img-div" (click)="fn_FetchProducts(cat.ID)">
                    <img class="cat-image img-fluid" src="{{cat.CoverImage}}">
                    <p class="cat-text hidden-overflow" [matTooltip]="cat.Name">
                      {{cat.Name}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div #productListContainer [ngClass]="{'panel-step':true,'active':listPanels.product}">
            <div class="row">
              <div #productCard class="col-sm-6 col-md-4 product-sections" *ngFor="let product of productList; index as i">
                <div class="store-item-thumb" [ngClass]="{'discontinuedProduct': !product.IsActive, 'product-selected': isProductSelected(product.ProductId)}">
                  <span [ngClass]="product.CustomizationType?.length < 13 ? (product.CustomizationType?.length < 10 ? (product.CustomizationType?.length < 7 ? 'dec-type5' : 'dec-type7') : 'dec-type10') : 'dec-type13'" >{{product.CustomizationType}}</span>

                  <!-- Selected Checkbox Icon -->
                  <div class="selected-checkbox" *ngIf="designData && isProductSelected(product.ProductId)">
                    <i class="fa fa-check-circle"></i>
                  </div>

                  <!--Conditional based isActive display-->
                  <div class="ribbon" *ngIf="!product.IsActive">
                    <span>
                      Discontinued
                    </span>
                  </div>
                  <div class="ribbon ribbon-{{product.ProductAdditionalInfo.ProductType}}"
                       *ngIf="product.IsActive && product.ProductAdditionalInfo != null">
                    <span>
                      {{product.ProductAdditionalInfo.ProductType}}
                    </span>
                  </div>

                  <div class="img-selected" *ngIf="product.IsActive"
                       (click)="!designData ? fn_CustomizeProduct(product.ProductId,product.CategoryId,product.StyleId) : null">
                    <div *ngIf="isProductLoading(product.ProductId)" class="preview-loader">
                      <i class="fa fa-spinner fa-spin"></i>
                    </div>
                    <img class="slected-image" [src]="getProductCurrentImage(product)">
                  </div>
                  <div class="img-selected" *ngIf="!product.IsActive">
                    <div *ngIf="isProductLoading(product.ProductId)" class="preview-loader">
                      <i class="fa fa-spinner fa-spin"></i>
                    </div>
                    <img class="slected-image" src="{{getProductCurrentImage(product)}}">
                  </div>

                  <!-- Side thumbnails with per-side placement dropdown — only the sides this
                       product actually has (not always all 4), each independently showing/setting
                       its own print location instead of one shared tab-driven row. -->
                  <div class="side-thumbnails-row" *ngIf="designData && getActiveCardRegions(product).length > 0">
                    <div class="side-thumb-col" *ngFor="let region of getActiveCardRegions(product)">
                      <div class="side-thumb-row">
                        <span class="side-thumb-label">{{ region }}</span>
                        <div class="side-thumb-img" [class.active-thumbnail]="getCardRegion(product) === region"
                             (click)="selectProductImage(product, getThumbnailForRegion(product, region))">
                          <img src="{{ getThumbnailForRegion(product, region) || 'assets/img/load.gif' }}" alt="" />
                        </div>
                      </div>
                      <div class="side-placement-dropdown"
                           *ngIf="getRegionChips(product, region).length > 0"
                           (click)="$event.stopPropagation()">
                        <button type="button" class="side-placement-toggle"
                                (click)="toggleLocationDropdown(product, region, $event)">
                          <span class="side-placement-toggle-label">{{ getSelectedRegionChip(product, region)?.description }}</span>
                          <i class="fa fa-caret-down"></i>
                        </button>
                        <div class="side-placement-menu" *ngIf="isLocationDropdownOpen(product, region)">
                          <div class="side-placement-option"
                               *ngFor="let chip of getRegionChips(product, region)"
                               [class.active]="isSideLocationSelected(product, region, chip)"
                               (click)="selectSideLocation(product, region, chip.impressDecorationLocationCodeId, $event); closeLocationDropdown()">
                            {{ chip.description }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Browse-only / legacy mode: plain thumbnail strip, no per-side dropdown -->
                  <div class="main-pro-bottom-img-bottm prdt-btm-lx"
                       *ngIf="!designData && getProductImageList(product).length > 0">
                    <ul>
                      <li *ngFor="let img of getProductImageList(product)"
                          (click)="selectProductImage(product, img)"
                          [class.active-thumbnail]="isThumbnailActive(product, img)">
                        <div>
                          <img src="{{img || 'assets/img/load.gif'}}" alt="" />
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!--Conditional based isActive display-->
                  <div *ngIf="product.ProductAdditionalInfo?.Label" class="row label-row">
                    <ng-container *ngFor="let label of getLabelArray(product.ProductAdditionalInfo.Label)">
                      <div class="col-md-2 label-col text-center">
                        {{ label.trim() }}
                      </div>
                    </ng-container>
                  </div>
                  <div class="">
                    <ng-container *ngIf="product.IsActive">
                      <!-- Browse-only mode: View Detail button -->
                      <div class="row" *ngIf="isBrowseOnly">
                        <div class="col-md-12">
                          <button
                            class="btn btn-custom btn-add-product"
                            (click)="viewProductDetail(product.ProductId)"
                            style="background: #5bbab4;">
                            <i class="fa fa-eye"></i> View Detail
                          </button>
                        </div>
                      </div>

                      <!-- Show Edit design + Add-to-build buttons if design data exists -->
                      <div class="action-buttons-row" *ngIf="designData && !isBrowseOnly">
                        <button
                          class="btn btn-edit-design"
                          [disabled]="!isProductSelected(product.ProductId)"
                          [title]="!isProductSelected(product.ProductId) ? 'Add this product to the build first' : ''"
                          (click)="customizeProduct(product)">
                          <i class="fa fa-pencil"></i> Edit design
                        </button>
                        <button
                          class="btn btn-add-product"
                          (click)="toggleProductSelection(product)"
                          [ngClass]="{
                            'btn-selected': isProductSelected(product.ProductId),
                            'btn-empty': !isProductSelected(product.ProductId) && getStagedColorwayCount(product) === 0
                          }">
                          <i class="fa" [ngClass]="isProductSelected(product.ProductId) ? 'fa-check' : 'fa-plus'"></i>
                          {{ getAddToBuildLabel(product) }}
                        </button>
                      </div>

                      <!-- Show original buttons if no design data -->
                      <div class="row" *ngIf="!designData && !isBrowseOnly">
                        <ng-container *ngIf="(userRole == 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember') || fn_IsAddProductUrl()">
                          <div *ngIf="product.ProductAdditionalInfo?.Enable_Embroidery" class="col-md-6 dv-cstm">
                            <button class="btn btn-custom" data-toggle="dropdown">
                              Customize
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item"
                                 (click)="fn_CustomizeProduct(product.ProductId,product.CategoryId,product.StyleId, true)">
                                New
                                Design
                              </a>
                              <a class="dropdown-item" (click)="fn_OpenDesignList(product)">Choose Existing</a>
                            </div>
                          </div>
                          <div *ngIf="!product.ProductAdditionalInfo?.Enable_Embroidery" class="col-md-6 dv-cstm">
                            <button (click)="fn_CustomizeProduct(product.ProductId,product.CategoryId,product.StyleId, true)"
                                    class="btn btn-custom">
                              Customize
                            </button>
                          </div>
                        </ng-container>
                        <div class="col-md-6" [ngClass]="{'dv-dtils': userRole == 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'}" *ngIf="!fn_IsAddProductUrl()">
                          <button (click)="gotoDetailPage(product.ProductId)" class="btn btn-custom">
                            Details
                          </button>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div class="store-item-cntnt hidden-overflow">
                    <h4 title="{{product.Description}}">
                      {{
product.Description.length > 40 ? (product.Description | slice:0:40) + '..'
                      :(product.Description)
                      }}
                      <span class="badge badge-primary float-right"
                            *ngIf="product.IsActive && product.ProductAdditionalInfo != null && product.ProductAdditionalInfo.Enable_BulkOrder">
                        Accept
                        Bulk
                      </span>
                    </h4>
                    <small>
                      Starting <span class="price">{{product.UnitCost |currency:'USD':'symbol':'1.2-2' }}</span>
                    </small>
                  </div>

                  <p class="available-sizes hidden-overflow">
                    Size: <strong>
                      <ng-container *ngFor="let size of product.Sizes">
                        {{size.Name}}
                      </ng-container>
                    </strong>
                  </p>

                  <!-- WI 1378 — pick the decoration to design against; carries to the color page -->
                  <div class="card-decoration-type" *ngIf="designData && !isBrowseOnly && product.decorations?.length > 1">
                    <span class="card-decoration-label">Decoration Type</span>
                    <select class="card-decoration-select"
                            [value]="product.selectedDecorationTypeId"
                            (change)="onCardDecorationChange(product, $event)">
                      <option *ngFor="let dec of product.decorations" [value]="dec.DecorationTypeId">{{ dec.Name }}</option>
                    </select>
                  </div>

                  <div class="colorway-status" *ngIf="designData && !isBrowseOnly">
                    <span>Colorways</span>
                    <span class="colorway-status-count">{{ getStagedColorwayCount(product) }} of {{ product.Styles.length }} selected</span>
                  </div>
                  <!-- Legacy browse-only / single-select swatches: unchanged nowrap+ellipsis row -->
                  <div class="display-inline" *ngIf="!(designData && !isBrowseOnly)">
                    <div class="col-10 color-list tick hidden-overflow" [class.visible-overflow]="clicked === i">
                      <!--Conditional based isActive display-->
                      <ng-container *ngFor="let s of product.Styles">
                        <div title="{{s.Name}}" class="available-colors" *ngIf="s.IsActive"
                             [ngStyle]="displayColor(s.HtmlColor1)"
                             [ngClass]="{'selected-style': s.ID == product.StyleId}"
                             (click)="selectStyleToCustomize(s,i)">
                        </div>
                      </ng-container>
                    </div>
                    <div class="col-2 color-count" (click)="clicked = (clicked === i ? null :i)"
                    title="Click to view {{product.Styles.length}} Colors">
                    {{product.Styles.length}}
                  </div>
                </div>

                <!-- Colorway staging swatches: one row, "+N more" reveals the rest -->
                <div class="colorway-swatch-block" *ngIf="designData && !isBrowseOnly">
                  <div class="colorway-swatch-row tick">
                    <ng-container *ngFor="let s of getVisibleColorwaySwatches(product)">
                      <div title="{{s.Name}}" class="available-colors"
                           [ngStyle]="displayColor(s.HtmlColor1)"
                           [ngClass]="{'selected-style': isColorwayStaged(product, s)}"
                           (click)="toggleColorwayStaged(product, s, i, $event)">
                      </div>
                    </ng-container>
                  </div>
                  <button type="button" class="colorway-more-btn"
                          *ngIf="getHiddenColorwaySwatchCount(product) > 0"
                          (click)="toggleColorwaySwatchRowExpanded(product, $event)">
                    +{{ getHiddenColorwaySwatchCount(product) }} more
                  </button>
                </div>
                <div class="colorway-tray" *ngIf="designData && !isBrowseOnly && getStagedColorwayCount(product) > 0">
                  <span class="colorway-tray-count">{{ getStagedColorwayCount(product) }} colorway{{ getStagedColorwayCount(product) === 1 ? '' : 's' }} staged</span>
                  <ng-container *ngIf="getAllSelectedSideLocationNames(product) as locationNames">
                    <ng-container *ngIf="locationNames.length"> &middot; {{ locationNames.join(' · ') }}</ng-container>
                  </ng-container>
                </div>
            </div>

              </div>
            </div>
            <mat-card class="spg-mat-card mat-card-cmn" style="display: none;" [ngStyle]="{'display': isDisplay}">
              <mat-card-content>
                <div class="text-center">
                  <span> No records available</span>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <!-- Modal -->
        <div *ngIf="mobileScreen" class="modal fade d-md-none" id="open-mobile-filter" tabindex="-1"
             aria-labelledby="open-mobile-filterLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <app-filter (getProducts)="updateProductList($event)" [filterModel]="filterModel" [filterList]="filterList"
                            [pageSize]="pageSize" [searchCustomizedForm]="searchForm"></app-filter>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Footer Actions (shown when design data exists, hidden in browse-only mode) -->
  <div class="footer-actions" *ngIf="designData && !isBrowseOnly">
    <div class="footer-summary">
      <p>Ready to continue with <strong>{{selectedProductsCount}}</strong> product{{selectedProductsCount !== 1 ? 's' : ''}}</p>
      <p class="products-info" *ngIf="selectedProductsCount === 0">
        <i class="fa fa-exclamation-triangle"></i> No products selected
      </p>
    </div>
    <div class="footer-buttons">
      <button mat-stroked-button (click)="goBackToDesignPreview()" class="btn-secondary">
        <mat-icon>arrow_back</mat-icon>
        Back to Design Preview
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="continueWithSelectedProducts()"
        [disabled]="selectedProductsCount === 0 || exportPreviewsInFlight > 0"
        class="btn-continue">
        <span *ngIf="exportPreviewsInFlight > 0">
          <i class="fa fa-spinner fa-spin"></i> Generating Previews...
        </span>
        <span *ngIf="exportPreviewsInFlight === 0">
          Continue with {{selectedProductsCount}} Product{{selectedProductsCount !== 1 ? 's' : ''}}
          <mat-icon>arrow_forward</mat-icon>
        </span>
      </button>
    </div>
  </div>
</div>

<!-- DesignHuddle Editor Modal -->
<div *ngIf="showDesignHuddleEditorModal" class="dh-editor-overlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999;">
  <!-- Backdrop -->
  <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7);"
       (click)="closeDesignHuddleEditorModal()"></div>

  <!-- Modal Content -->
  <div style="position: absolute; top: 20px; left: 20px; right: 20px; bottom: 20px; background: #fff; border-radius: 8px; z-index: 10000; display: flex; flex-direction: column; overflow: hidden;">
    <!-- Header -->
    <div style="padding: 12px 20px; border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;">
      <h4 style="margin: 0; font-size: 18px;">Customize: {{editorProductName}}</h4>
      <button (click)="dismissDesignHuddleEditorModal()" title="Close without saving"
              style="background: transparent; border: none; cursor: pointer; font-size: 20px; line-height: 1; color: #888; padding: 4px 8px;">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div style="flex: 1; position: relative; overflow: hidden;">
      <!-- Loading Spinner -->
      <div *ngIf="isCreatingProject" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #f9f9f9; z-index: 1;">
        <div style="text-align: center;">
          <i class="fa fa-spinner fa-spin" style="font-size: 48px; color: #007bff;"></i>
          <p style="margin-top: 16px; font-size: 16px; color: #555;">Loading editor...</p>
        </div>
      </div>
      <div id="dh-editor-container" style="width: 100%; height: 100%;"></div>
    </div>

    <!-- Footer -->
    <div style="padding: 12px 20px; border-top: 1px solid #e0e0e0; display: flex; justify-content: flex-end; flex-shrink: 0;">
      <button (click)="closeDesignHuddleEditorModal()" style="background: #4caf50; color: #fff; border: none; font-size: 14px; cursor: pointer; padding: 8px 24px; border-radius: 4px; font-weight: 500;">Save & Close</button>
    </div>
  </div>
</div>
